<template>
    <div v-if="!hide"  class="form-network form-network-twitter">
         <details open>
            <summary>{{ $t('dash.post-creator.form.twitter.text-options') }} <i class="fa-solid fa-caret-down"></i></summary>
            <div class="content-detail">
                <div class="type-switch">
                    {{ $t('dash.post-creator.form.twitter.split-text') }}
                    <ComponentSwitch :value="formData.formDataNetwork.twitter.tweetSplitting ? formData.formDataNetwork.twitter.tweetSplitting.active : false" :onChange="handlerTweetSplitting" :id="'switch-settings-advanced-twitter-1'"></ComponentSwitch>
                </div>
            </div>      
        </details>
        <details v-if="formData.urlsTextContentHistory.length && this.textContentLength + 23 <= this.maxCharactersText" open>
            <summary>{{ $t('dash.post-creator.form.link-preview') }} <i class="fa-solid fa-caret-down"></i></summary>
            <div class="content-detail form-link">
                <div class="list-thubmmail">

                    <div class="thubmmail" v-for="(url) in this.formData.urlsTextContentHistory" @click="()=>selectUrl(url)" :key="url">
                        <Checkbox :id="url" :prefixId="'thubmmail-'" 
                            :isChecked="(formDataNetwork.snippet.link == url)" 
                            :isDisable="(formDataNetwork.snippet.link == url)"
                            :add="selectUrl" 
                            :remove="()=>{}"
                        />
                        <SnippetNetwork :link="url"/>
                     
                    </div>
                </div>
               
               
            </div>
            
        </details>
    </div>
</template>

<script>
    import { EventBus } from '@/event-bus';
    import store from '@/store/index.js';
    import ComponentSwitch from '@/components/dash/utils/switch.vue'
    import SnippetNetwork from './../SnippetNetwork.vue'
    import minxinBot from '@/components/mixins/Bots.vue'
    import minxinPost from '@/components/mixins/Posts.vue'
    import Checkbox from '@/components/dash/utils/checkbox.vue'

    import {formatFileAcceptedByNetwork} from './../../../constante.js'
    export default {

        components: {
            ComponentSwitch,
            SnippetNetwork,
            Checkbox
        },
        mixins: [minxinBot,minxinPost],

        props: {
            hide : {
                type: Boolean,
                default: false
            },
            formData: {
                type: Object,
                default: () => ({})
            },
            formDataNetwork: {
                type: Object,
                default: () => ({})
            },
            files:Object,
            maxCharactersText:Number
        },
        
        data() {
            return {
                inputModel:{
                    switchCustomSnippet: false,
                 
                },
                lastModeSelected : undefined
            }
        },
        
        created () {
            
        },

        mounted () {
            if (this.formData.formDataNetwork.twitter) this.formDataNetwork = this.formData.formDataNetwork.twitter
        },

        methods: {
            addMode(mode) {
                this.lastModeSelected = mode
                EventBus.$emit("postCreatorAddMode", mode);
            },

            handlerTweetSplitting(state) {
                this.formDataNetwork.tweetSplitting.active = state
                this.$emit('setFormDataNetwork', 'twitter', this.formDataNetwork)
            },

            selectTypeContent(typeContent = '') {
                this.formDataNetwork.typeContent = this.formDataNetwork.typeContent == typeContent ? '' : typeContent
                this.$emit('setFormDataNetwork', 'twitter', this.formDataNetwork)
            },

            selectUrl(url) {
                if (!this.formDataNetwork.snippet) this.formDataNetwork.snippet = {}
                this.formDataNetwork.snippet.link = this.formDataNetwork.snippet.link == url ? '' : url
                this.$emit('setFormDataNetwork', 'twitter', this.formDataNetwork)
            },

            verifUrlSelected() {
                if (this.textContentLength + 23 > this.maxCharactersText) {
                    this.selectUrl('')
                    return
                }
                if (this.formData.urlsTextContentHistory.length) {
                    let linkSelect = this.formDataNetwork && this.formDataNetwork.snippet && this.formDataNetwork.snippet.link ? this.formDataNetwork.snippet.link : null
                    if ((linkSelect && !this.formData.urlsTextContentHistory.includes(linkSelect))) {
                        this.selectUrl('')
                    }
                }else{
                    this.selectUrl('')
                }
             
            },

            selectTypeMedia(typeMedia = 'image') {
                this.formDataNetwork.typeMedia = typeMedia
                this.$emit('setFormDataNetwork', 'twitter', this.formDataNetwork)
            },

            detectTypeContent() {
                console.log('detectTypeContent')


                if(this.formData.files.length) { 
                    try {
                        for (let index = 0; index < this.formData.files.length; index++) {
                            const fileId = this.formData.files[index].id;
                            if (this.files[fileId] && ['video','image'].includes(this.files[fileId].info.type2)) {
                                this.formDataNetwork.typeContent = this.files[fileId].info.type2
                                this.selectUrl('')
                                break
                            }
                        }
                        this.$emit('setFormDataNetwork', 'twitter', this.formDataNetwork)
                    } catch (error) {
                        console.error("Impossible de definir le type content")
                    }
                }

            },

            fileAdded() {
                this.detectTypeContent()
            }
        },

        computed: {
            allPages() {
                return this.$store.getters['selectPage/selectPageAllPages'];
            },
            pagesSelected() {
                return this.$store.getters['selectPage/selectPagePageSelected'].map(id => this.allPages[id]);
            },
            textContentLength() {
                const twttr = require('twitter-text')
                
                    
                return twttr.default.parseTweet(
                    this.formData.textContent.replace(/\\n/g, '\n').replace(/@(\d{13})/g, (match, id) => {
                        const mention = this.formData.mentions[id];
                        if (mention) {
                            return mention.mention && mention.mention.twitter ? `@${mention.mention.twitter.name || mention.mention.twitter.id}` : mention.textDefault;
                        }
                        return match;
                    })
                ).weightedLength
                
            }
        },

        watch: {
            ['formData.formDataNetwork.twitter']() {
                if (this.formData.formDataNetwork.twitter) this.formDataNetwork = this.formData.formDataNetwork.twitter
            },

            'formData.urlsTextContent'(newValue) {
                this.verifUrlSelected()
            },

            'formData.urlsTextContentHistory'(newValue) {
                this.verifUrlSelected()
            },
            textContentLength: {
                immediate: true,
                handler(newValue, oldValue) {
                    this.verifUrlSelected()
                }
            }
        },

        beforeDestroy () {
        
        }
        
    }
</script>